export default "__VITE_ASSET__Rh_bCQsk__"